/**
 * Mirror of `DEFAULT_CURRENCIES` from rp-integrations
 * (src/modules/pay-operations/order-amendments/constants/amendment.constants.ts).
 *
 * Keep this list in sync with the backend until a shared enum API is introduced.
 */
export const CURRENCIES = [
  'EUR',
  'CHF',
  'GBP',
  'DKK',
  'NOK',
  'SEK',
  'PLN',
  'CZK',
  'HUF',
  'RON',
  'BGN',
  'HRK',
  'ISK',
  'UAH',
] as const;

export type Currency = (typeof CURRENCIES)[number];
